"use client";

import { c as _c } from "react/compiler-runtime";
import { Rocket } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
type FlyingRocketProps = {
  show: boolean;
};
const FlyingRocket = t0 => {
  const $ = _c(13);
  const {
    show
  } = t0;
  const controls = useAnimation();
  const [showFlame, setShowFlame] = useState(false);
  const wasPendingRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== controls || $[1] !== show) {
    t1 = () => {
      if (show) {
        wasPendingRef.current = true;
        const run = async () => {
          await controls.start({
            x: [-1.5, 1.5, -1.5, 1.5, 0],
            transition: {
              duration: 0.35,
              ease: "easeInOut"
            }
          });
          await controls.start({
            y: -28,
            x: 10,
            rotate: -45,
            opacity: 0,
            transition: {
              duration: 0.3,
              ease: "easeIn"
            }
          });
          controls.set({
            y: 28,
            x: -10,
            rotate: -45,
            opacity: 0
          });
          await controls.start({
            y: 0,
            x: 0,
            rotate: 0,
            opacity: 1,
            transition: {
              duration: 0.3,
              ease: "easeOut"
            }
          });
          setShowFlame(true);
          controls.start({
            y: [0, -4, 0],
            rotate: [0, -8, 0],
            transition: {
              duration: 1.2,
              repeat: Infinity,
              ease: "easeInOut"
            }
          });
        };
        run();
      } else {
        if (wasPendingRef.current) {
          wasPendingRef.current = false;
          queueMicrotask(() => setShowFlame(false));
          controls.stop();
          controls.start({
            y: 0,
            x: 0,
            rotate: 0,
            opacity: 1,
            transition: {
              duration: 0.25,
              ease: "easeOut"
            }
          });
        }
      }
    };
    t2 = [controls, show];
    $[0] = controls;
    $[1] = show;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "inline-flex",
      position: "relative"
    };
    t4 = <Rocket size={16} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== showFlame) {
    t5 = showFlame && <motion.span key="flame" style={{
      position: "absolute",
      bottom: -4,
      left: 2,
      width: 5,
      height: 10,
      background: "linear-gradient(to bottom, #fde68a, #fb923c, #ef4444)",
      borderRadius: "50% 50% 40% 40%",
      filter: "blur(1px)",
      transformOrigin: "top center"
    }} initial={{
      scaleY: 0,
      opacity: 0
    }} animate={{
      scaleY: [0.7, 1.4, 0.8, 1.2, 0.9],
      scaleX: [1, 0.7, 1.1, 0.8, 1],
      opacity: [0.9, 1, 0.8, 1, 0.9]
    }} exit={{
      scaleY: 0,
      opacity: 0
    }} transition={{
      duration: 0.5,
      repeat: Infinity,
      ease: "easeInOut"
    }} />;
    $[6] = showFlame;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <AnimatePresence>{t5}</AnimatePresence>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== controls || $[11] !== t6) {
    t7 = <motion.span animate={controls} style={t3}>{t4}{t6}</motion.span>;
    $[10] = controls;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default FlyingRocket;